import Vue from 'vue';
import moment from 'moment';

moment.locale('zh-cn');

Vue.filter('moment', (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') => moment(dataStr).format(pattern));
